import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const VentureUp = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsVentureUp" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls="controls" className="d-block w-100 carousel-item-img">
                                    <source src="../IMG/VentureUp/VentureUp.mp4" type="video/mp4" />
                                </video>
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/VentureUp/Vission.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/VentureUp/CompanyPage.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/VentureUp/BlogPage.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/VentureUp/ProfilePage.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="VentureUp" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">VentureUp</p>
                            <p className="Project--info--subheading">Frontend Web Development</p>
                            <p className="Project--info--subheading">Backend Development</p>
                            <p className="Project--info--Para">A bespoke ecosystem for founders, mentors, and investors. Experience isolated social growth with curated connections, mentorship, and investment opportunities, fostering a unique environment for professional development.</p>
                            <p className="Project--info--Para">Venture Up allows founders to pitch their ideas and receive
                                valuable feedback advice from experienced mentors and investors, helping them to refine
                                and improve their pitch and increase their chances of success.</p>
                        </div>
                        <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/Vihaan_VentureUp" target='__blank'>Github</a>
                            <a href="https://devfolio.co/projects/venture-up-ac07" target='__blank'>DevFolio</a>
                        </div>
                        <div className="Project--info--tech">
                            <p>Flutter</p>
                            <p>Python</p>
                            <p>MongoDB</p>
                            <p>Html/Css</p>
                            <p>Bootstrap</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VentureUp